'use client'

import * as React from 'react'
import { Check, Minus } from 'lucide-react'
import { cn } from 'lib/utils'

export interface CustomCheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  indeterminate?: boolean
}

const TableRowCheckbox = React.forwardRef<HTMLInputElement, CustomCheckboxProps>(
  ({ className, indeterminate, ...props }, ref) => {
    const innerRef = React.useRef<HTMLInputElement>(null)

    React.useEffect(() => {
      if (innerRef.current) {
        innerRef.current.indeterminate = !!indeterminate
      }
    }, [indeterminate])

    React.useImperativeHandle(ref, () => innerRef.current!)

    return (
      <div className="relative inline-flex items-center cursor-pointer ">
        <input
          type="checkbox"
          ref={innerRef}
          onClick={(e) => e.stopPropagation()}
          aria-label={props['aria-label'] || 'Table row selection'}
          onChange={(e) => {
            e.stopPropagation()
            props.onChange?.(e)
          }}
          className={cn(
            'peer h-4 w-4 shrink-0 rounded-sm border border-primary ring-offset-background focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 appearance-none',
            className,
          )}
          {...props}
        />
        <div
          className={cn(
            'absolute inset-0 flex items-center justify-center text-primary-foreground pointer-events-none rounded-sm',
            props.checked || indeterminate ? 'opacity-100' : 'opacity-0',
            props.checked || indeterminate ? 'bg-primary' : 'bg-transparent',
          )}
        >
          {indeterminate ? <Minus className="h-3 w-3" /> : <Check className="h-3 w-3" />}
        </div>
      </div>
    )
  },
)
TableRowCheckbox.displayName = 'TableRowCheckbox'

export { TableRowCheckbox }
